export const getImageUrl = (imageUrl) => {
  return `${process.env.React_App_Image}/${imageUrl}`;
};
